function interpolateTemplate(template, params = {}) {
  return String(template || '').replace(/\{(\w+)\}/g, (_, key) => {
    const value = params[key]
    return value === null || value === undefined ? '' : String(value)
  })
}

function normalizePath(path) {
  return String(path || '').replace(/^\/+/, '')
}

function getReportId(report) {
  if (!report) {
    return ''
  }
  return report.id || ''
}

function normalizeQuery(query) {
  return String(query || '')
    .replace(/^&+|&+$/g, '')
    .split('&')
    .filter(part => part && !/^[^=]+=$/.test(part))
    .join('&')
}

function appendParam(parts, key, value) {
  if (value !== null && value !== undefined && value !== '') {
    parts.push(`${key}=${value}`)
  }
}

function buildMiniProgramUrl(options = {}) {
  const env = options.env || {}
  const report = options.report || null

  if (env.VUE_APP_MINIPROGRAM_URL) {
    return env.VUE_APP_MINIPROGRAM_URL
  }

  const appId = env.VUE_APP_MINIPROGRAM_APPID || ''
  const path = normalizePath(env.VUE_APP_MINIPROGRAM_PATH || 'pages/reportDetail/index')
  const queryTemplate = env.VUE_APP_MINIPROGRAM_QUERY || 'report_id={id}'
  const envVersion = env.VUE_APP_MINIPROGRAM_ENV_VERSION || 'release'

  if (!appId || !path) {
    return ''
  }

  const query = normalizeQuery(interpolateTemplate(queryTemplate, {
    id: getReportId(report),
  }))

  const params = []
  appendParam(params, 'appid', appId)
  appendParam(params, 'path', path)
  appendParam(params, 'query', query)
  appendParam(params, 'env_version', envVersion)

  return `weixin://dl/business/?${params.join('&')}`
}

module.exports = {
  buildMiniProgramUrl,
  normalizePath,
}
